import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { fetchNextSearchResults, fetchSearchResults } from 'apps/chat/actions/searchActions'
import { SearchMessageItem } from 'shared/api/requests/chat/search/schemas'

interface SearchState {
  items: SearchMessageItem[] | null
  fetching: boolean
  total: number
  limiter: number | null
  activeMessageId: number | null
}

const initialState: SearchState = {
  items: null,
  fetching: false,
  total: 0,
  limiter: null,
  activeMessageId: null,
}

const searchSlice = createSlice({
  name: 'chat/search',
  initialState,
  reducers: {
    setActiveMessageId(state, action: PayloadAction<number | null>) {
      state.activeMessageId = action.payload
    },
    resetSearch() {
      return initialState
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSearchResults.pending, (state) => {
        state.fetching = true
        state.items = null
        state.limiter = null
        state.total = 0
      })
      .addCase(fetchSearchResults.fulfilled, (state, action) => {
        state.fetching = false
        state.items = action.payload.messages
        state.total = action.payload.total
        state.limiter = action.payload.limiter
      })
      .addCase(fetchSearchResults.rejected, (state) => {
        state.fetching = false
      })
      .addCase(fetchNextSearchResults.pending, (state) => {
        state.fetching = true
      })
      .addCase(fetchNextSearchResults.fulfilled, (state, action) => {
        state.fetching = false
        const existingItems = state.items ?? []
        state.items = [...existingItems, ...action.payload.messages]
        state.total = action.payload.total
        state.limiter = action.payload.limiter
      })
      .addCase(fetchNextSearchResults.rejected, (state) => {
        state.fetching = false
      })
  },
})

export const searchActions = searchSlice.actions
export const searchReducer = searchSlice.reducer
